import { Typography } from 'antd';
import { LegalDocumentLayout } from 'components/LegalDocumentLayout';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import routes from 'routes';

export const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const { Text, Title } = Typography;
  const textStyle = { fontSize: '14px', fontWeight: 300 };
  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('legal.privacy-title')} | ${process.env.PROJECT_NAME}`}</title>
        <meta name="description" content={t('legal.privacy-meta-description')} />
      </Helmet>
      <LegalDocumentLayout>
          <Title level={4}>{t('legal.privacy-title')}</Title>
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.service-title')}
          </Text>
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '18px', fontWeight: '300' }}>
            {t('legal.website-url')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.introduction-p1')}
            <br />
            <br />
            {t('legal.privacy-content.introduction-p2')}
            <br />
            <br />
            {t('legal.privacy-content.introduction-p3')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>{t('legal.privacy-sections.key-terms')}</Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.key-terms-p1')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p2')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p3')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p4')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p5')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p6')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p7')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p8')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p9')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p10')}
            <br />
            <br />
            {t('legal.privacy-content.key-terms-p11')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.applicable-data-protection-legislation')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.applicable-data-protection-legislation')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.the-privacy-policy')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.the-privacy-policy-body-p1')}
            <br />
            <br />
            {t('legal.privacy-content.the-privacy-policy-body-p2')}
            <br />
            <br />
            {t('legal.privacy-content.the-privacy-policy-body-p3')}
            <br />
            <br />
            {t('legal.privacy-content.the-privacy-policy-body-p4')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.lawful-processing-and-legal-basis')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.lawful-processing-intro')}
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>
                {t('legal.privacy-content.lawful-processing-list.item-1-before-link')}{' '}
                <Link to={routes.termsOfUse} target="_blank">
                  {' '}
                  {t('legal.privacy-content.lawful-processing-list.item-1-link-url')}
                </Link>
                {t('legal.privacy-content.lawful-processing-list.item-1-after-link')}
              </li>
              <li>{t('legal.privacy-content.lawful-processing-list.item-2')}</li>
              <li>
                {t('legal.privacy-content.lawful-processing-list.item-3-intro')}
                <br />
                <ul style={{ listStyleType: 'circle', marginLeft: '15px' }}>
                  <li>{t('legal.privacy-content.lawful-processing-list.item-3-nested.item-1')}</li>
                  <li>{t('legal.privacy-content.lawful-processing-list.item-3-nested.item-2')}</li>
                  <li>{t('legal.privacy-content.lawful-processing-list.item-3-nested.item-3')}</li>
                  <li>{t('legal.privacy-content.lawful-processing-list.item-3-nested.item-4')}</li>
                  <li>{t('legal.privacy-content.lawful-processing-list.item-3-nested.item-5')}</li>
                </ul>
              </li>
              <li>{t('legal.privacy-content.lawful-processing-list.item-4')}</li>
            </ul>
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.how-we-collect-personal-data')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.how-we-collect-intro')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.privacy-content.how-we-collect-list.directly')}</li>
              <li>{t('legal.privacy-content.how-we-collect-list.automatically')}</li>
              <li>{t('legal.privacy-content.how-we-collect-list.third-parties')}</li>
            </ul>
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.what-personal-data-we-collect')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.what-personal-data-p1')}
            <br />
            <br />
            {t('legal.privacy-content.what-personal-data-p2')}
            <br />
            <br />
            {t('legal.privacy-content.what-personal-data-list-intro')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.privacy-content.what-personal-data-list.item-1')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-2')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-3')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-4')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-5')}</li>
              <li>
                {t('legal.privacy-content.what-personal-data-list.item-6-intro')}
                <ul style={{ listStyleType: 'circle', marginLeft: '15px' }}>
                  <li>{t('legal.privacy-content.what-personal-data-list.item-6-nested.item-1')}</li>
                  <li>{t('legal.privacy-content.what-personal-data-list.item-6-nested.item-2')}</li>
                </ul>
              </li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-7')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-8')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-9')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-10')}</li>
              <li>{t('legal.privacy-content.what-personal-data-list.item-11')}</li>
            </ul>
            <br />
            <br />
            {t('legal.privacy-content.what-personal-data-p3')}
            <br />
            <br />
            {t('legal.privacy-content.what-personal-data-p4')}
            <br />
            <br />
            {t('legal.privacy-content.what-personal-data-p5')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.with-whom-we-share-personal-data')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.with-whom-we-share-intro')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.privacy-content.with-whom-we-share-list.group-companies')}</li>
              <li>{t('legal.privacy-content.with-whom-we-share-list.service-providers')}</li>
              <li>{t('legal.privacy-content.with-whom-we-share-list.third-party-apps')}</li>
              <li>{t('legal.privacy-content.with-whom-we-share-list.legal-required')}</li>
              <li>{t('legal.privacy-content.with-whom-we-share-list.business-reorganisation')}</li>
              <li>{t('legal.privacy-content.with-whom-we-share-list.consent')}</li>
            </ul>
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.storage-and-sub-processors')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.storage-p1-before-link')}
            <Link to={routes.termsOfUse} target="_blank">
              {' '}
              {t('legal.privacy-content.storage-terms-link-url')}
            </Link>
            {t('legal.privacy-content.storage-p1-after-link')}
            <br />
            <br />
            {t('legal.privacy-content.storage-p2-before-azure-link')}{' '}
            <a
              href={t('legal.privacy-content.storage-azure-link-url')}
              target="_blank"
            >
              {t('legal.privacy-content.storage-azure-link-url')}
            </a>
            <br />
            <br />
            {t('legal.privacy-content.storage-p3-before-zoho-links')}{' '}
            <a
              href={t('legal.privacy-content.storage-zoho-link-url-1')}
              target="_blank"
            >
              {t('legal.privacy-content.storage-zoho-link-url-1')}
            </a>
            ,
            <a
              href={t('legal.privacy-content.storage-zoho-link-url-2')}
              target="_blank"
            >
              {t('legal.privacy-content.storage-zoho-link-url-2')}
            </a>{' '}
            and
            <a
              href={t('legal.privacy-content.storage-zoho-link-url-3')}
              target="_blank"
            >
              {t('legal.privacy-content.storage-zoho-link-url-3')}
            </a>
            <br />
            <br />
            {t('legal.privacy-content.storage-p4')}
            <br />
            <br />
            {t('legal.privacy-content.storage-p5')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.international-data-transfers')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.international-transfers-before-link-1')}{' '}
            <a
              href={t('legal.privacy-content.international-transfers-link-url-1')}
              target="_blank"
            >
              {t('legal.privacy-content.international-transfers-link-url-1')}
            </a>
            {t('legal.privacy-content.international-transfers-between-links')}{' '}
            <a
              href={t('legal.privacy-content.international-transfers-link-url-2')}
              target="_blank"
            >
              {t('legal.privacy-content.international-transfers-link-url-2')}
            </a>
            {t('legal.privacy-content.international-transfers-after-link-2')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.what-are-your-rights')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.your-rights-before-email')}{' '}
            <a href={`mailto:${t('legal.contact-email')}`}>{t('legal.contact-email')}</a>
            {t('legal.privacy-content.your-rights-after-email')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.privacy-content.your-rights-list.item-1')}</li>
              <li>{t('legal.privacy-content.your-rights-list.item-2')}</li>
              <li>{t('legal.privacy-content.your-rights-list.item-3')}</li>
              <li>{t('legal.privacy-content.your-rights-list.item-4')}</li>
              <li>{t('legal.privacy-content.your-rights-list.item-5')}</li>
              <li>{t('legal.privacy-content.your-rights-list.item-6')}</li>
            </ul>
            <br />
            <br />
            {t('legal.privacy-content.your-rights-p1')}
            <br />
            <br />
            {t('legal.privacy-content.your-rights-p2')}
            <br />
            <br />
            {t('legal.privacy-content.your-rights-p3')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.security-and-protection')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.security-p1')}
            <br />
            <br />
            {t('legal.privacy-content.security-p2')}
            <br />
            <br />
            {t('legal.privacy-content.security-p3')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.retention-of-personal-data')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.retention-p1')}
            <br />
            <br />
            {t('legal.privacy-content.retention-p2')}
            <br />
            <br />
            {t('legal.privacy-content.retention-p3')}
            <br />
            <br />
            {t('legal.privacy-content.retention-p4')}
            <br />
            <br />
            {t('legal.privacy-content.retention-p5')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>{t('legal.privacy-sections.cookies')}</Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.cookies-p1')}
            <br />
            <br />
            {t('legal.privacy-content.cookies-p2')}
            <br />
            <ul style={{ listStyleType: 'disc', margin: '15px' }}>
              <li>{t('legal.privacy-content.cookies-list.item-1')}</li>
              <li>{t('legal.privacy-content.cookies-list.item-2')}</li>
              <li>{t('legal.privacy-content.cookies-list.item-3')}</li>
              <li>{t('legal.privacy-content.cookies-list.item-4')}</li>
            </ul>
            <br />
            {t('legal.privacy-content.cookies-p3')}
            <br />
            <br />
            {t('legal.privacy-content.cookies-p4')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.internet-communications')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.internet-communications')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.links-to-other-websites')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.links-to-other-websites')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>{t('legal.privacy-sections.updates')}</Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.updates-p1')}
            <br />
            <br />
            {t('legal.privacy-content.updates-p2')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <Text style={{ fontSize: '20px', fontWeight: '300' }}>
            {t('legal.privacy-sections.how-can-you-contact-us')}
          </Text>
          <br />
          <br />
          <Text style={textStyle}>
            {t('legal.privacy-content.contact-us-before-email')}{' '}
            <a href={`mailto:${t('legal.contact-email')}`}>{t('legal.contact-email')}</a>{' '}
            {t('legal.privacy-content.contact-us-after-email')}
          </Text>
          <br />
          <br />
          <br />
          <br />
          <br />
          <Text style={textStyle}>
            <i>{t('legal.privacy-last-updated')}</i>
          </Text>
          <br />
          <br />
      </LegalDocumentLayout>
    </React.Fragment>
  );
};
